import { Box, Icon, Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'
import amex from 'assets/images/billing/amex.svg'
import dinersClubInternational from 'assets/images/billing/diners-club-internacional.svg'
import discover from 'assets/images/billing/discover.svg'
import jcb from 'assets/images/billing/jcb.svg'
import masterCard from 'assets/images/billing/master-card.svg'
import visa from 'assets/images/billing/visa.svg'

import InputText from 'modules/core/components/Inputs/Text'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { ChargebeeSubscriptionForm } from '../../FullScreenStep/form'
import { clearCVV, clearCardExpiry, clearCardNumber } from '../helpers'

type Props = {
  form: ChargebeeSubscriptionForm
}

const CreditCardFields = ({ form }: Props) => {
  const [open, toggle] = useToggle(false)

  return (
    <Box gap="s12">
      <InputText
        label={i18n.t('pricing_plans.billing_information.form.card_info')}
        field={form.get('card_number')}
        placeholder={i18n.t('pricing_plans.billing_information.form.card_number')}
        onChange={(e) => {
          form.setErrors({ card_number: {} })
          form.setValues({ card_number: clearCardNumber(e.value) })
        }}
        onBlur={() => {
          if (form.get('card_number').value !== '' && !form.isValidCardNumber) {
            track(trackingEvents.billing.upgradePlanError, {
              error_message: 'Invalid card number',
              value: form.get('card_number').value,
            })
            form.setErrors({
              card_number: [
                i18n.t('pricing_plans.billing_information.form.validation.invalid_card_number'),
              ],
            })
          }
        }}
        mandatory
      />
      <Box gap="s8" flexDirection="row">
        <Box gap="s12" flexDirection="row">
          <InputText
            field={form.get('card_expiry')}
            placeholder={i18n.t('pricing_plans.billing_information.form.card_expiry')}
            onChange={(e) => {
              form.setErrors({ card_expiry: {} })
              form.setValues({ card_expiry: clearCardExpiry(e.value) })
            }}
            onBlur={() => {
              switch (form.getErrorCardExpiry) {
                case 'invalid':
                  track(trackingEvents.billing.upgradePlanError, {
                    error_message: 'Invalid card expiry',
                    value: form.get('card_expiry').value,
                  })
                  form.setErrors({
                    card_expiry: [
                      i18n.t(
                        'pricing_plans.billing_information.form.validation.invalid_card_expiry'
                      ),
                    ],
                  })
                  break
                case 'expired':
                  track(trackingEvents.billing.upgradePlanError, {
                    error_message: 'Card expired',
                    value: form.get('card_expiry').value,
                  })
                  form.setErrors({
                    card_expiry: [
                      i18n.t(
                        'pricing_plans.billing_information.form.validation.expired_card_expiry'
                      ),
                    ],
                  })
                  break
              }
            }}
            mandatory
          />
          <InputText
            field={form.get('card_cvv')}
            placeholder={i18n.t('pricing_plans.billing_information.form.card_cvv')}
            onChange={(e) => {
              form.setErrors({ card_cvv: {} })
              form.setValues({ card_cvv: clearCVV(e.value) })
            }}
            onBlur={() => {
              if (form.get('card_cvv').value !== '' && !form.isValidCardCVV) {
                track(trackingEvents.billing.upgradePlanError, {
                  error_message: 'Invalid CVV',
                  value: form.get('card_cvv').value,
                })
                form.setErrors({
                  card_cvv: [
                    i18n.t('pricing_plans.billing_information.form.validation.invalid_card_cvv'),
                  ],
                })
              }
            }}
            mandatory
          />
        </Box>
        <Box alignSelf="center">
          <Tooltip.Alt
            attachment="middle left"
            open={open}
            toggle={toggle}
            label={i18n.t('pricing_plans.billing_information.form.card_cvv_info')}
          >
            <Icon.Medium icon="info-circle-line" color="grey800" />
          </Tooltip.Alt>
        </Box>
      </Box>
      <Box gap="s8">
        <Box gap="s8" flexDirection="row">
          <img src={visa} />
          <img src={masterCard} />
          <img src={discover} />
          <img src={amex} />
          <img src={jcb} />
          <img src={dinersClubInternational} />
        </Box>
        <Text.Normal size="100">
          {i18n.t('pricing_plans.billing_information.form.card_info_description')}
        </Text.Normal>
      </Box>
    </Box>
  )
}

export default CreditCardFields
